import React from 'react';
import {Select} from "antd";
import {QueryKey} from "@tanstack/react-query";
import {useCommonUseQuery} from "../../../../../Common/hooks/rest/ReacQueryHook";
import {BurkData} from "../../index/DocumentMgr/data/UserData";
import {procAdminService} from "../../../../../Common/util/ProcService";

interface Option {
    value: string | number;
    label: string;
    children?: Option[];
}

export interface SelectBurkProps{
    onChangeValue:(value:string)=>void,
}


function SelectBurk(props:SelectBurkProps)
{
    const {onChangeValue} = props;
    const serviceCode:string       =   process.env.REACT_APP_SERVICE_NAME as string;
    const queryKey:QueryKey =   [`BurkData`];
    const { data} = useCommonUseQuery<BurkData[]>(
        queryKey,
        () =>procAdminService<BurkData[]>("post", `${serviceCode}ADS11`, null));

    const onChange = (value: string[]) => {
        console.log(value);
    };

    function getOption(input:BurkData[]):{ label: string | null; value: string | null }[]
    {
        let options: { label: string | null; value: string | null }[] = [{
            value:"ALL", label:"전체"
        }]
        return options.concat( input.map(burkData => ({value: burkData.burkCd, label: burkData.burkName})) );
    }

    const options: { label: string | null; value: string | null }[] = data ? getOption(data) : [{
            value: 'Loading',
            label: 'Loading...',
        },
    ];

    return (
     <Select
        style={{width:"180px", marginRight:"10px"}}
        onChange={(value, selectedOptions) => {
            const selectedValue = Array.isArray(value) ? value.join(', ') : value;
            onChangeValue(selectedValue); // 문자열 또는 문자열 배열
        }}
        options={options}
        placeholder={"법인정보"}
    />
    );
};

export default SelectBurk;
